import React, { createContext, useState, useContext } from 'react';

// Crear el contexto
const ValorDolarContext = createContext();

// Proveedor del contexto
export const DolarProvider = ({ children }) => {
  const [valorDolar, setValorDolar] = useState(0); // Estado inicial del dólar

  // Función para actualizar el valor del dólar
  const actualizarValorDolar = (nuevoValor) => {
    setValorDolar(nuevoValor);
  };

  // Valores y funciones que estarán disponibles en el contexto
  return (
    <ValorDolarContext.Provider value={{ valorDolar, actualizarValorDolar }}>
      {children}
    </ValorDolarContext.Provider>
  );
};

// Hook para usar el contexto
export const useDolar = () => {
  return useContext(ValorDolarContext);
};
